<ion-item
  class="d-flex align-item-center border-light-2 input-wrapper margin-top-m"
  lines="none"
  [class.change-padding]="!numeric && gpa != null"
  >
  <ion-input
    inputmode="decimal"
    type="number"
    [placeholder]="placeholder"
    (ionInput)="valueSelected(gpa)"
    [(ngModel)]="gpa"
    autocomplete="off"
    enterkeyhint="next"
    step=".01"
    debounce="400"
    mode="md"
  ></ion-input>
  @if (!numeric && gpa != null) {
    <span>%</span>
  }
</ion-item>
